import Quimbee from 'quimbee'
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import { waitForQuimbeeDataKey } from 'controllers/quimbee_data_controller'

// Note this is for Algolia's autocomplete v0.x. Importing syntax changes in v1.x.

class AlgoliaSearchSupport {
  static client
  static index

  static initIndex() {
    AlgoliaSearchSupport.client = AlgoliaSearchSupport.client || algoliasearch(Quimbee.data.algolia.contentSearch.appId, Quimbee.data.algolia.contentSearch.searchKey)
    AlgoliaSearchSupport.index = AlgoliaSearchSupport.index || AlgoliaSearchSupport.client.initIndex(Quimbee.data.algolia.contentSearch.indexName)
  }

  constructor(inputSelector, suggestionTemplate, onSelect, filters, classNames) {
    this.inputSelector = inputSelector
    this.suggestionTemplate = suggestionTemplate
    this.onSelect = onSelect
    this.filters = filters || ""
    this.classNames = classNames || {}
  }

  async initialize() {
    await waitForQuimbeeDataKey("algolia")

    AlgoliaSearchSupport.initIndex()

    this.setupAutocomplete()

    return this
  }

  setupAutocomplete() {
    const _this = this

    autocomplete({
      container: _this.inputSelector,
      onSubmit: (params) => {
        const state = params.state

        if (state.query.length > 0) {
          window.location = `/search?query=${state.query}`
        }
      },
      detachedMediaQuery: "none",
      placeholder: "Search for cases, videos, and more",
      classNames: {
        input: "algolia-autocomplete-search-box",
        root: "algolia-autocomplete",
        ..._this.classNames
      },
      getSources() { return _this.buildSources() }
    })
  }

  buildSources() {
    const _this = this
    const searchClient = AlgoliaSearchSupport.client

    return [
      {
        sourceId: 'querySuggestions',
        onSelect: _this.onSelect,
        getItemInputValue: ({ item }) => item.query,
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [ { indexName: Quimbee.data.algolia.contentSearch.indexName, query, params: { hitsPerPage: 5, filters: _this.filters } } ]
          })
        },
        templates: {
          item({ item, _components, html }) {
            return html([_this.suggestionTemplate(item)])
          }
        }
      }
    ]
  }
}

export default AlgoliaSearchSupport
